import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  href: "/",
  class: "no-underline text-900 ml-2"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "white-space-nowrap overflow-hidden text-overflow-ellipsis hidden sm:inline w-5 md:w-auto" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "pi pi-user"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-5rem" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_LogoutButton = _resolveComponent("LogoutButton")!
  const _component_Toolbar = _resolveComponent("Toolbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "p-4 absolute top-0 left-0 right-0 z-2",
      style: _normalizeStyle({ background: _ctx.computedBgColor })
    }, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          (_ctx.appLogo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "h-2rem w-2rem",
                src: _ctx.appLogo,
                alt: _ctx.appName
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true),
          _createElementVNode("a", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.appName), 1)
          ])
        ]),
        end: _withCtx(() => [
          (_ctx.webId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.webId,
                class: "no-tap-highlight no-underline text-900 gap-2 flex align-items-center justify-content-end"
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.name), 1),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_Avatar, {
                      key: 0,
                      shape: "circle",
                      class: "border-1 mx-2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.img)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.img
                            }, null, 8, _hoisted_5))
                          : (_openBlock(), _createElementBlock("i", _hoisted_6))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_3))
            : _createCommentVNode("", true),
          (!_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_LoginButton, {
                key: 1,
                redirectUri: _ctx.redirect_uri
              }, null, 8, ["redirectUri"]))
            : (_openBlock(), _createBlock(_component_LogoutButton, { key: 2 }))
        ]),
        _: 1
      })
    ], 4),
    _hoisted_7
  ], 64))
}